import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { isMobile } from 'react-device-detect';

const WarningPopUp = ({ modal, title, content, onToggleModal, onConfirm, confirmText, cancelText, isLoading }) => {
  return (
    <Dialog
      open={modal}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onToggleModal();
        }
      }}
      className="add-lease-dialog"
       aria-labelledby="scroll-dialog-title"
    >
      <DialogTitle id="warning-popup-title" className='dialog-header' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 34, borderRadius: '50%', background: '#FBEBC0', flexShrink: 0 }}>
          <WarningAmberIcon sx={{ color: '#a78701', fontSize: 20 }} />
        </Box>
        <Typography sx={{ fontWeight: 600, color: '#5c4a05', fontFamily: 'Roboto' }}>
          {title ? title : 'Warning'}
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 2.5, py: 2.2 }}>
        <Box sx={{ minWidth: isMobile ? 'auto' : '360px', p: 1.6, textAlign:"center" }}>
          <Typography sx={{ lineHeight: 1.6, color: '#4a4a4a', fontFamily: 'Roboto' }}>
            {content}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.6 }}>
        <Button className='cancel-btn' variant="outlined" size='small' onClick={onToggleModal} color='primary'>{cancelText ? cancelText : 'Cancel'}</Button>
        <Button variant="contained" size="small" onClick={onConfirm} sx={{ background: '#a78701', '&:hover': { background: '#8c7101' } }}>
          {isLoading ? <CircularProgress color="inherit" size={18} /> : (confirmText ? confirmText : 'Continue')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default WarningPopUp;
